<template>
    <b-container>
        <b-card v-if="userName===null && userData.username===null">
            <h4> Create a new User </h4>
        </b-card>
        <b-card v-if="userName!==null || userData.username!==null">
            <h4> Reset User: {{userData.username}} Password</h4>
        </b-card>
        <b-card>
            <b-form @submit="onSubmit">
                <b-form-group
                    id="input-group-2"
                    label="New Password:"
                    label-for="input-2"
                    description="New Password">
                    <b-form-input
                        id="input-2"
                        v-model="userData.new_password"
                        type="password"
                        placeholder="new password"
                    ></b-form-input>
                </b-form-group>
                <b-button type="submit" variant="primary"> {{buttonText}}</b-button>
            </b-form>
        </b-card>
    </b-container>
</template>
<script>
import {UserApi} from "@/api/userApi";
import { userMixin } from "@/mixins/userMixin";
import handleError from "@/errorHandler";
export default {
    name: "WardUserPasswordReset",
    mixins: [userMixin],
    props: {
        userName: {
            type: String,
            required: false,
            default: 'me'
        }
    },
    data () {
        return {
            options: [],
            userData: {
                username: null,
                password: null,
                email: null,
                full_name: null,
                ward_id: null,
                stake_id: null,
                application_roles: [],
                disabled: false,
                new_password: null,
            }
        }
    },
    computed:{
        buttonText(){
            if(this.userName === 'me')
                return "Update"
            return "Reset"
        }
    },
    async mounted() {
        await this.getUser();

    },
    methods: {
        async getMe() {
            const { data } = await UserApi.getUser();
            //console.log(data);
            this.userData = data;
        },
        async getUser() {
            const { data } = await UserApi.getUserDetailWard(this.userName);
            this.userData = data

        },
        async onSubmit(event) {
            event.preventDefault();
            let data = {
                new_password: this.userData.new_password,
                change_pass_on_login: true,
                ward_id: this.userData.ward_id,
                stake_id: this.userData.stake_id
            };
            try{
                //console.log(data);
                const {response} = await UserApi.resetWardUserCredentials(this.userName, data);
                this.$toast.success("Successfully Updated User");0
                //console.log(response);
                this.$router.push({ name: 'ward-user-detail', params: {'userName':this.userName, 'wardId': this.userData.ward_id} });
            }catch(e) {
                handleError(e, "Could not update credentials");

            }
        }
    }
}
</script>
<style lang="scss" scoped>
</style>
